import React from 'react'
import "./aboutme.css"
import parse from "html-react-parser";
function Bio(props) {
    return (
        <>
        <div {...props}>
            <div className="rounded shadow py-3">
                <span className="manpro font-normal block text-gray-600 text-lg mx-3 pb-2 border-b border-solid border-gray-300 uppercase">Bio</span>
                <p className="mb-0 font-normal manpro text-gray-500 text-sm pt-2 px-3">
                    {/* {props.biocontent && parse(props.biocontent)} */}
                    {/* props.biocontent */}
                    {props.biocontent}
                </p>
            </div>
        </div>   
        </>
    )
}

export default Bio
